import script from "./BasketCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BasketCard.vue?vue&type=script&setup=true&lang=js"

import "./BasketCard.vue?vue&type=style&index=0&id=3937dbc0&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3937dbc0"]])

export default __exports__